import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    show_masking: false,
    activeIndex: 0, // 导航-激活项
    userName: '',
    userImg: '',
    companyStatus: 0, // 企业中心-企业信息的审核状态：1 通过
    isShowJobInfo: true,
    notificationCount: 0 // 未读消息数量
  },
  getters: {},
  mutations: {
    SET_MASKING: (state, show_masking) => {
      state.show_masking = show_masking
    },
    SET_ACTIVEINDEX: (state, activeIndex) => {
      state.activeIndex = activeIndex
    },
    SET_USERNAME: (state, userName) => {
      state.userName = userName
    },
    SET_USERTYPE: (state, userType) => {
      state.userType = userType
    },
    SET_COMPANYNAME: (state, companyName) => {
      state.companyName = companyName
    },
    SET_USERIMG: (state, userImg) => {
      state.userImg = userImg
    },
    SET_COMPANYSTATUS: (state, companyStatus) => {
      state.companyStatus = companyStatus
    },
    SET_ISSHOWJOBINFO: (state, isShowJobInfo) => {
      state.isShowJobInfo = isShowJobInfo
    },
    SET_NOTIFICATIONCOUNT: (state, notificationCount) => {
      state.notificationCount = notificationCount
    },
  },
  actions: {},
  modules: {},
});
export default store
